"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultationCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="consultationcta" data-nav="light" ref={ref} className="relative bg-background py-16 sm:py-20 lg:py-24 text-foreground transition-opacity duration-700" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-primary px-6 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-20 text-primary-foreground shadow-2xl border border-secondary/20">
          {/* Subtle background ambient luxury accents */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />

          <div className="relative z-10 mx-auto max-w-4xl text-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-secondary/30 bg-secondary/10 px-3.5 py-1 text-xs font-medium tracking-wide text-secondary uppercase mb-6">
              <Sparkles className="size-3.5" />
              <span>Tailored Advisory</span>
            </div>

            <h2 className="font-serif text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl lg:text-5xl leading-tight">
              Looking for tailored revenue insights for your property?
            </h2>

            <p className="mt-6 text-lg sm:text-xl leading-relaxed text-primary-foreground/90 font-sans max-w-2xl mx-auto">
              Sunil Singh offers revenue audits and bespoke OTA channel structuring.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold px-8 py-6 rounded-md shadow-lg transition-all duration-200 group">
                <Link to="#" className="inline-flex items-center gap-2">
                  <span>Book a Consultation</span>
                  <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}